import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import { PackActionTypeFromGetMany } from '@/models/actionType';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';
import { formatCurrency } from '@/utils/number';
import useViewPort from '@/utils/useViewport';

import PackActionName from './PackActionName';
import { RefusedByClientBadge } from './RefusedByClientBadge';

export const PackActionDropdownItem = ({
  packAction,
  refusedByClient,
}: {
  packAction: PackActionTypeFromGetMany;
  refusedByClient: boolean;
}) => {
  const { isMobile } = useViewPort();

  const { view: requestView } = useRequestContext();
  const { iam } = useArticleContext();

  const showWorkshopPrice = requestView.workshopPrice.shown;
  const showOrganizationPrice = requestView.organizationPrice.shown;

  const showWorkshopAmountBeforeTaxes = requestView.workshopPrice.showAmountBeforeTaxes;
  const showOrganizationAmountBeforeTaxes = requestView.organizationPrice.showAmountBeforeTaxes;

  return (
    <Stack
      row
      alignItems="center"
      justifyContent="space-between"
      gap="0.5rem"
      flexWrap="nowrap"
      style={{ flex: 1 }}
    >
      <Stack row alignItems="center" gap="0.5rem" flexWrap="nowrap">
        <PackActionName
          packActionType={
            !iam.hasOnlyWorkshopScopeOnArticle && !!packAction.refashionBonus
              ? Object.assign(packAction, {
                  actions: packAction.actions.map((action) =>
                    Object.assign(action, {
                      refashionStatus: action.refashionId ? 'applied' : undefined,
                    })
                  ),
                })
              : packAction
          }
          alwaysShowActions
          style={{ textAlign: 'start' }}
        />
        {refusedByClient && <RefusedByClientBadge />}
      </Stack>
      <Stack
        {...(isMobile
          ? { alignItems: 'flex-end' }
          : { row: true, alignItems: 'center', gap: '0.5rem', flexWrap: 'nowrap' })}
      >
        {showWorkshopPrice && (
          <Paragraph>
            {formatCurrency(
              showWorkshopAmountBeforeTaxes
                ? packAction.dynamicCost?.amountBeforeTaxes
                : packAction.dynamicCost?.amount,
              packAction.dynamicCost?.currency
            )}
          </Paragraph>
        )}
        {showOrganizationPrice && (
          <Paragraph weight="medium">
            {formatCurrency(
              showOrganizationAmountBeforeTaxes
                ? packAction.dynamicPrice?.amountBeforeTaxes
                : packAction.dynamicPrice?.amount,
              packAction.dynamicPrice?.currency
            )}
          </Paragraph>
        )}
      </Stack>
    </Stack>
  );
};
